import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  form_container: {
    width: '100%',
    marginTop: '1.25rem',
    '& .chkbox-field': {
      marginBottom: '2rem',
      '&:last-of-type': {
        marginBottom: '3.25rem',
      },
    },
  },
  submit_button: {
    width: '100%',
    height: '3.25rem',
    [theme.breakpoints.up('viewportMedium')]: {
      width: '12.5rem',
    },
  },
  input_group_container: {
    [theme.breakpoints.up('viewportMedium')]: {
      '& > div:first-child': {
        paddingRight: '0.75rem',
        '& p': {
          marginRight: '0.75rem',
        },
      },
      '& > div:last-child': {
        paddingLeft: '0.75rem',
      },
    },
  },
  input_container: {
    marginBottom: '2rem',
  },
  input: {
    width: '100%',
    height: '3.125rem',
    backgroundColor: colors.off_white,
    border: 'solid 0.0625rem',
    borderColor: colors.mid_grey_2,
    padding: '0.875rem 1.125rem',
  },
  spinner: {
    background: 'transparent',
    position: 'relative',
    display: 'inline-block',
    zIndex: 2,
    height: '2.25rem',
    width: '2.25rem',
    '&:before': {
      animation: '$slide-spin .75s linear infinite',
      borderRadius: '50%',
      borderRight: '0.125rem solid transparent',
      borderTop: `0.125rem solid ${colors.white}`,
      content: "''",
      height: '1.5625rem',
      width: '1.5625rem',
      position: 'absolute',
      boxSizing: 'border-box',
      left: '0.375rem',
      top: '0.3125rem',
    },
  },
  '@keyframes slide-spin': {
    to: {
      transform: 'rotate(360deg)',
    },
  },
});
